exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tippy-box{font-size:12px;word-break:break-all}", ""]);

// exports
